import * as actionTypes from '../../constants/actionTypes';

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_LANGUAGE_SUCCESS:
    case actionTypes.GET_LANGUAGE_ERROR:
      return action.payload.map(lang => {
        return {
          ...lang,
          label: lang.name,
          value: lang.code,
        };
      });
    default:
      return state;
  }
}
